import React from 'react'
import {field} from "../../generic/tables";
import EditModalChildren from "./EditModalChildren";
import DirectoryTemplate from "../DirectoryTemplate";
import {FaCheck, FaTimes} from "react-icons/fa";
import {COUNTRIES} from "sv-common/constants/bases";
import {ENTITIES, getPermissions} from "../../../lib/utils/hooks/useRoleSystem";
import {t} from "i18next";
import getCountryValue from '../../../lib/utils/getCountryValue';

const columns = [
  field(t('directories.subscriptions.name'), true, "name"),
  field(t('directories.subscriptions.country'), true, "country",
    res => COUNTRIES[res.country]),

  field(t('directories.subscriptions.price'), true, "price_value",
    res => res.price_value + ' ' + res.price_currency),

  field(t('directories.subscriptions.active'), true, "active",
    res => res.active ? <FaCheck color={'green'}/> : <FaTimes color={'red'}/>),

  field(t('directories.subscriptions.commonDiscount'), true, "keel_all_luch_group_discount_size",
    res => res.keel_all_luch_group_discount_size + '%'),
];

const getColumns = () => {
  const countryColumns = getCountryValue({
    ru: [
      field(t('directories.subscriptions.individualDiscount'), true, "luch_individual_discount_size", res => (res.luch_individual_discount_size || 0) + '%'),
      field(t('directories.subscriptions.raceDiscount'), true, "race_discount_size", res => (res.race_discount_size || 0) + '%'),
      field(t('directories.subscriptions.raceDiscountCup'), true, "cup_discount_size", res => (res.cup_discount_size || 0) + '%'),
    ],
    en: [
      field(t('directories.subscriptions.sailGPDiscount'), true, "sail_gp_discount_size", res => (res.sail_gp_discount_size || 0) + '%'),
      field(t('directories.subscriptions.raceDiscountCup'), true, "cup_discount_size", res => (res.cup_discount_size || 0) + '%'),
    ]
  });

  return [...columns, ...countryColumns];
}

const Subscriptions = (props) => {
    return <DirectoryTemplate
        fields={getColumns()}
        entityName={'subscriptions'}
        EditModalChildren={EditModalChildren}
        editable
        deletable
        permissions={getPermissions(ENTITIES.SUBSCRIPTIONS)}
        {...props}
    />
}


export default Subscriptions;